import PropertyFeeManagement from "../view/PropertyFee/PropertyFeeManagement/PropertyFeeManagement";
import PropertyFeeManagementAdd from "../view/PropertyFee/PropertyFeeManagement/PropertyFeeManagementAdd";
import ElectricityQuota from "../view/PropertyFee/PropertyFeeManagement/ElectricityQuota";
import PropertyCollectionFee from "../view/PropertyFee/PropertyCollectionFee/PropertyCollectionFee";
import TemporaryParkingFee from "../view/PropertyFee/TemporaryParkingFee/TemporaryParkingFee";
import electricityShareFee from "../view/PropertyFee/electricityShareFee/electricityShareFee";
import invoicePowerConsumption from "../view/PropertyFee/electricityShareFee/invoicePowerConsumption";
import PropertyFeeManagementNav from "../view/PropertyFee/PropertyFeeManagementNav";

export default [
  {
    path: "/property_fee_management",
    name: "property-fee-management",
    components: {
      default: PropertyFeeManagementNav,
      a: PropertyFeeManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/property_fee_management_add",
    name: "property-fee-management-add",
    components: {
      default: PropertyFeeManagementNav,
      a: PropertyFeeManagementAdd
    }
  },
  {
    path: "/electricity_quota",
    name: "electricity-quota",
    components: {
      default: PropertyFeeManagementNav,
      a: ElectricityQuota
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/property_collection_fee",
    name: "property-collection-fee",
    components: {
      default: PropertyFeeManagementNav,
      a: PropertyCollectionFee
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/temporary_parking_fee",
    name: "temporary-parking-fee",
    components: {
      default: PropertyFeeManagementNav,
      a: TemporaryParkingFee
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electricity_share_fee",
    name: "electricity-share-fee",
    components: {
      default: PropertyFeeManagementNav,
      a: electricityShareFee
    }
  },
  {
    path: "/invoice_power_consumption",
    name: "invoice-power-consumption",
    components: {
      default: PropertyFeeManagementNav,
      a: invoicePowerConsumption
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/PropertyFee.js